import { render, staticRenderFns } from "./webinar-list.vue?vue&type=template&id=73f20252&"
import script from "./webinar-list.vue?vue&type=script&lang=js&"
export * from "./webinar-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports